var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { createEdgePositionedBarTooltipContent } from '@web/components/layout/RechartsItems/EdgePositionedBarTooltip';
import { rechartsDiagonalStripeFillUrl, rechartsDiagonalStripePatternDefs, rechartsDiagonalStripeSwatchCss } from '@web/components/layout/RechartsItems/rechartsDiagonalStripes';
import { Widget } from '@web/components/layout/Widget';
import { WidgetChartPlotArea } from '@web/components/layout/WidgetChartPlotArea/WidgetChartPlotArea';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { WORKDAY_ALIGNMENT_WITH_TEAM_CONFIG } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { renderTooltipDateHeading } from '@web/utility/ tooltip/tooltipDateLabel';
import { TooltipDateHeaderSection } from '@web/utility/ tooltip/tremorTooltip';
import { formatChartDayPeriodAxisLabel, getPeriodBarChartLayoutProps } from '@web/utility/charts';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { getInterval } from '@workalizer/shared/utils';
import { format, set } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
var formatHour = function (hour) {
    var date = new Date();
    var dateWithHour = set(date, {
        hours: hour,
        minutes: 0,
        seconds: 0,
        milliseconds: 0
    });
    return format(dateWithHour, 'h a');
};
var parseTimeToHours = function (timeString) {
    var _a = timeString.split(':').map(Number), hours = _a[0], minutes = _a[1];
    return Math.round((hours + minutes / 60) * 100) / 100;
};
var formatWorkDayRange = function (startTime, endTime) {
    return "".concat(startTime.slice(0, 5), " - ").concat(endTime.slice(0, 5));
};
var formatWorkDayRangeOrEmpty = function (startTime, endTime) {
    if (startTime && endTime) {
        return formatWorkDayRange(startTime, endTime);
    }
    return '';
};
var TooltipContent = function (_a) {
    var active = _a.active, payload = _a.payload, label = _a.label, t = _a.t, userId = _a.userId, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
    if (!active || !payload || !payload.length)
        return null;
    var data = payload[0].payload;
    var hasWorkDayData = data.startWorkTime && data.endWorkTime;
    var hasTeamData = data.teamAverageStartWorkTime && data.teamAverageEndWorkTime;
    if (!hasWorkDayData && !hasTeamData)
        return null;
    var workDayRange = hasWorkDayData
        ? formatWorkDayRange(data.startWorkTime, data.endWorkTime)
        : null;
    var teamRange = hasTeamData
        ? formatWorkDayRange(data.teamAverageStartWorkTime, data.teamAverageEndWorkTime)
        : null;
    return (_jsxs("div", __assign({ className: "bg-white border border-gray-200 rounded-lg shadow-lg p-4 min-w-[200px]" }, { children: [_jsx(TooltipDateHeaderSection, { children: _jsx("p", __assign({ className: "text-sm font-normal text-gray-900" }, { children: renderTooltipDateHeading(String(label !== null && label !== void 0 ? label : ''), {
                        referenceDateFrom: dateFrom,
                        referenceDateTo: dateTo
                    }) })) }), _jsxs("div", __assign({ className: "space-y-2" }, { children: [userId && hasWorkDayData && (_jsxs("div", __assign({ className: "flex items-center justify-between" }, { children: [_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [_jsx("div", { className: "w-2 h-2 rounded-full", style: {
                                            backgroundColor: WORKDAY_ALIGNMENT_WITH_TEAM_CONFIG.workDay.chartColor
                                        } }), _jsx("span", __assign({ className: "text-sm text-gray-600" }, { children: t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.workDay') }))] })), _jsx("span", __assign({ className: "text-sm font-semibold text-gray-900" }, { children: workDayRange }))] }))), hasTeamData && (_jsxs("div", __assign({ className: "flex items-center justify-between gap-2" }, { children: [_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [_jsx("div", { className: "w-2 h-2 rounded-full", style: userId
                                            ? {
                                                background: rechartsDiagonalStripeSwatchCss(WORKDAY_ALIGNMENT_WITH_TEAM_CONFIG.teamAverageWorkDay
                                                    .chartColor)
                                            }
                                            : {
                                                backgroundColor: WORKDAY_ALIGNMENT_WITH_TEAM_CONFIG.workDay.chartColor
                                            } }), _jsx("span", __assign({ className: "text-sm text-gray-600" }, { children: t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.teamAverageWorkDay') }))] })), _jsx("span", __assign({ className: "text-sm font-semibold text-gray-900" }, { children: teamRange }))] })))] }))] })));
};
export var WorkdayAlignmentWithTeam = function (_a) {
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
    var t = useTranslation().t;
    var _b = trpc.workdayAlignmentWithTeam.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }), data = _b.data, isLoading = _b.isLoading, refetch = _b.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var interval = getInterval(dateFrom, dateTo);
    var chartData = data.map(function (item) {
        var startTime = item.startWorkTime
            ? parseTimeToHours(item.startWorkTime)
            : null;
        var endTime = item.endWorkTime
            ? parseTimeToHours(item.endWorkTime)
            : null;
        var teamStartTime = item.teamAverageStartWorkTime
            ? parseTimeToHours(item.teamAverageStartWorkTime)
            : null;
        var teamEndTime = item.teamAverageEndWorkTime
            ? parseTimeToHours(item.teamAverageEndWorkTime)
            : null;
        return {
            period: item.period,
            workDayRange: startTime && endTime ? [startTime, endTime] : null,
            teamAverageWorkDayRange: teamStartTime && teamEndTime ? [teamStartTime, teamEndTime] : null,
            startWorkTime: item.startWorkTime,
            endWorkTime: item.endWorkTime,
            teamAverageStartWorkTime: item.teamAverageStartWorkTime,
            teamAverageEndWorkTime: item.teamAverageEndWorkTime
        };
    });
    var _c = getPeriodBarChartLayoutProps({
        barGroupCount: chartData.length,
        barsPerGroup: userId ? 2 : 1
    }), barGap = _c.barGap, barSize = _c.barSize, periodXAxis = _c.periodXAxis, periodBarChartMargin = _c.periodBarChartMargin;
    var chartPlotEmpty = isInsightsDataEmpty(data);
    var allTimes = chartData.flatMap(function (item) { return __spreadArray(__spreadArray([], (userId && item.workDayRange ? item.workDayRange : []), true), (item.teamAverageWorkDayRange || []), true); });
    var minTime = allTimes.length > 0 ? Math.min.apply(Math, allTimes) : 0;
    var maxTime = allTimes.length > 0 ? Math.max.apply(Math, allTimes) : 24;
    var yAxisDomain = [
        Math.max(0, Math.floor(minTime) - 1),
        Math.min(24, Math.ceil(maxTime) + 1)
    ];
    var legendItems = __spreadArray(__spreadArray([], (userId
        ? [
            {
                key: 'workDayRange',
                color: WORKDAY_ALIGNMENT_WITH_TEAM_CONFIG.workDay.color,
                label: t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.workDay')
            }
        ]
        : []), true), [
        {
            key: 'teamAverageWorkDayRange',
            color: userId
                ? WORKDAY_ALIGNMENT_WITH_TEAM_CONFIG.teamAverageWorkDay.color
                : WORKDAY_ALIGNMENT_WITH_TEAM_CONFIG.workDay.color,
            label: t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.teamAverageWorkDay')
        }
    ], false);
    var workDayChartColor = WORKDAY_ALIGNMENT_WITH_TEAM_CONFIG.workDay.chartColor;
    var teamAvgChartColor = WORKDAY_ALIGNMENT_WITH_TEAM_CONFIG.teamAverageWorkDay.chartColor;
    var teamBarStripePatternId = "".concat(InsightTypeEnum.workdayAlignmentWithTeam, "_teamAverageWorkDayRange");
    var teamBarFill = userId
        ? rechartsDiagonalStripeFillUrl(teamBarStripePatternId)
        : workDayChartColor;
    var renderWorkdayAlignmentTooltip = createEdgePositionedBarTooltipContent(function (props) { return (_jsx(TooltipContent, __assign({}, props, { t: t, userId: userId, dateFrom: dateFrom, dateTo: dateTo }))); }, chartData.length);
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: t(userId
                    ? 'app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.userWorkdayAlignmentWithTeam'
                    : 'app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.workdayAlignmentWithTeam'), description: t(userId
                    ? 'widgetTitleDescriptions.scheduleAndAttendance.userWorkdayAlignmentWithTeam'
                    : 'widgetTitleDescriptions.scheduleAndAttendance.workdayAlignmentWithTeam'), insightType: InsightTypeEnum.workdayAlignmentWithTeam, insightsData: data, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t(userId
                        ? 'app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.userWorkdayAlignmentWithTeam'
                        : 'app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.workdayAlignmentWithTeam'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, (data !== null && data !== void 0 ? data : []).map(function (item) {
                                    var _a, _b;
                                    var periodLabel = t('filters.period');
                                    var workDayLabel = t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.workDay');
                                    var teamLabel = t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.teamAverageWorkDay');
                                    var teamRange = formatWorkDayRangeOrEmpty(item.teamAverageStartWorkTime, item.teamAverageEndWorkTime);
                                    if (userId) {
                                        return _a = {},
                                            _a[periodLabel] = item.period,
                                            _a[workDayLabel] = formatWorkDayRangeOrEmpty(item.startWorkTime, item.endWorkTime),
                                            _a[teamLabel] = teamRange,
                                            _a;
                                    }
                                    return _b = {},
                                        _b[periodLabel] = item.period,
                                        _b[teamLabel] = teamRange,
                                        _b;
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(data) }) }), _jsxs(Widget, { children: [_jsx("div", __assign({ className: "flex gap-8 lg:gap-8 mb-6 p-4 ml-2 rounded-lg justify-start flex-wrap" }, { children: legendItems.map(function (item) { return (_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [item.key === 'teamAverageWorkDayRange' && userId ? (_jsx("div", { className: "h-4 w-4 shrink-0 rounded border border-gray-200", style: {
                                        background: rechartsDiagonalStripeSwatchCss(teamAvgChartColor)
                                    }, "aria-hidden": true })) : (_jsx("div", { className: "w-4 h-4 rounded ".concat(item.color), "aria-hidden": true })), _jsx("span", __assign({ className: "text-sm font-medium" }, { children: item.label }))] }), item.key)); }) })), _jsx(WidgetChartPlotArea, __assign({ isEmpty: chartPlotEmpty }, { children: _jsx(ResponsiveContainer, __assign({ width: "100%", height: 400 }, { children: _jsxs(BarChart, __assign({ data: chartData, barGap: barGap, barSize: barSize, margin: periodBarChartMargin }, { children: [userId &&
                                        rechartsDiagonalStripePatternDefs([
                                            {
                                                patternId: teamBarStripePatternId,
                                                chartColor: teamAvgChartColor
                                            }
                                        ]), _jsx(CartesianGrid, { strokeDasharray: "3 3", stroke: "#f3f4f6" }), _jsx(XAxis, __assign({ dataKey: "period", axisLine: false, tickLine: false }, periodXAxis, { tickFormatter: function (value) {
                                            return formatChartDayPeriodAxisLabel(value, interval, {
                                                dateFrom: dateFrom,
                                                dateTo: dateTo
                                            });
                                        } })), _jsx(YAxis, { axisLine: false, tickLine: false, tick: { fontSize: 12, fill: '#6b7280' }, tickFormatter: formatHour, domain: yAxisDomain }), _jsx(Tooltip, { allowEscapeViewBox: { x: true, y: true }, content: renderWorkdayAlignmentTooltip }), userId && (_jsx(Bar, { dataKey: "workDayRange", fill: WORKDAY_ALIGNMENT_WITH_TEAM_CONFIG.workDay.chartColor, radius: [4, 4, 4, 4] })), _jsx(Bar, { dataKey: "teamAverageWorkDayRange", fill: teamBarFill, radius: [4, 4, 4, 4] })] })) })) }))] })] })));
};
